var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons:rectangle-stack-solid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.4259 9.70208C13.23 9.48406 14.0595 9.37407 14.8926 9.375H36.7676C37.6217 9.375 38.4467 9.48958 39.2322 9.70208C38.7127 8.66454 37.9147 7.79207 36.9275 7.18238C35.9403 6.57269 34.8029 6.24985 33.6426 6.25H18.0176C16.8569 6.24946 15.719 6.57212 14.7314 7.18184C13.7438 7.79155 12.9455 8.66422 12.4259 9.70208ZM5.51758 25C5.51758 23.3424 6.17606 21.7527 7.34816 20.5806C8.52026 19.4085 10.11 18.75 11.7676 18.75H39.8926C41.5502 18.75 43.1399 19.4085 44.312 20.5806C45.4841 21.7527 46.1426 23.3424 46.1426 25V37.5C46.1426 39.1576 45.4841 40.7473 44.312 41.9194C43.1399 43.0915 41.5502 43.75 39.8926 43.75H11.7676C10.11 43.75 8.52026 43.0915 7.34816 41.9194C6.17606 40.7473 5.51758 39.1576 5.51758 37.5V25ZM11.7676 15.625C10.9134 15.625 10.0884 15.7396 9.30091 15.9521C9.8205 14.9142 10.6188 14.0415 11.6064 13.4318C12.594 12.8221 13.7319 12.4995 14.8926 12.5H36.7676C37.9279 12.4998 39.0653 12.8227 40.0525 13.4324C41.0397 14.0421 41.8377 14.9145 42.3572 15.9521C41.5538 15.7342 40.725 15.6243 39.8926 15.625H11.7676Z",
    fill: "#152344"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.ea536a46c73f3d8cebae441752836ed2.svg";
export { ForwardRef as ReactComponent };